import { AdminRouteGuard } from "@shared/guards/AdminRouteGuard";
import AdminDashboardPage from "@features/admin/pages/admin-dashboard-page";
import AdminAnalyticsPage from "@features/admin/pages/analytics-page";
import SystemLogsPage from "@features/admin/pages/system-logs-page";
import SystemSettingsPage from "@features/admin/pages/system-settings-page";
import AdminPage from "@features/admin/pages/admin-page";
import CollectorsClientsPage from "@/features/admin/pages/collectors-clients-page";

export const adminRoutes = {
  path: "/admin",
  element: (
    <AdminRouteGuard>
      <AdminPage />
    </AdminRouteGuard>
  ),
  children: [
    {
      path: "/admin",
      element: <AdminDashboardPage />,
    },
    {
      path: "/admin/analytics",
      element: <AdminAnalyticsPage />,
    },
    {
      path: "/admin/logs",
      element: <SystemLogsPage />,
    },
    {
      path: "/admin/settings",
      element: <SystemSettingsPage />,
    },
    {
      path: "/admin/collectors",
      element: <CollectorsClientsPage />,
    },
  ],
};
